exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sent-emails-page pre{max-width:100%;word-wrap:break-word;white-space:pre-wrap;background:var(--white);border-radius:.25rem;border:1px solid var(--border);padding:1rem;margin-top:2rem}", ""]);

// exports
